import { useState, useEffect, useRef } from 'react';
import { Button, Input, Modal, Tabs } from 'antd';
import TabPane from 'rc-tabs/lib/TabPanelList/TabPane';
import { SearchOutlined } from '@ant-design/icons';
import profileIcon from 'Assets/Ellipse.svg';
import addUserIcon from 'Assets/addUserIcon.svg';
import trashBin from 'Assets/trashBin.svg';
import { Avatar } from 'Components/Contact/Avatar/Avatar';
import { PhoneLink } from 'Components/PhoneLink/PhoneLink';
import { ReactComponent as Phone } from 'Assets/links/white-phone.svg';
import { ReactComponent as Dots } from 'Assets/controls/triple-dots.svg';
import { IPrivateChat, IGroupChat } from 'Shared/Types/chat';
import { OptionsMenu } from './OptionsMenu/OptionsMenu';
import styles from './Header.module.scss';
import legacyStyles from 'Containers/Chat/Legacy.module.scss';

type HeaderParams = {
  activeChat: IPrivateChat | IGroupChat;
};

export const Header: React.FC<HeaderParams> = ({ activeChat }) => {
  const [optionsIsVisible, setOptionsIsVisible] = useState(false);
  const [groupInfo, setGroupInfo] = useState(false);
  const [addUsers, setAddUsers] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const optionsMenuRef = useRef<HTMLDivElement>(null);
  const dotsButtonRef = useRef<HTMLDivElement>(null);

  const handleGroupInfo = () => {
    setGroupInfo(true);
  };

  const handleAddUsers = () => {
    setAddUsers(true);
  };

  const handleDeleteModal = () => {
    setDeleteModal(true);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        optionsMenuRef.current &&
        !optionsMenuRef.current.contains(event.target as Node) &&
        dotsButtonRef.current &&
        !dotsButtonRef.current.contains(event.target as Node)
      ) {
        setOptionsIsVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.header}>
      <div className={styles.header__wrapper}>
        {'avatar' in activeChat && <Avatar avatarURL={activeChat.avatar} />}
        <span className={styles.header__info}>
          {'users_count' in activeChat ? (
            <>
              <button
                className={styles.header__info__groupInfoControl}
                onClick={handleGroupInfo}
              >
                <span className={styles.header__info__name}>
                  {activeChat.name}
                </span>
              </button>
              <span className={styles.header__info__usersCount}>
                {`${activeChat.users_count} ${
                  activeChat.users_count === 1 ? 'user' : 'users'
                }`}
              </span>
            </>
          ) : (
            <span className={styles.header__info__name}>{activeChat.name}</span>
          )}
        </span>
      </div>
      <div className={styles.header__controls}>
        {'user_phone' in activeChat && (
          <PhoneLink
            phoneNumber={activeChat.user_phone}
            icon={Phone}
            customStyles={`${styles.header__controls__control} ${styles.header__controls__call}`}
          />
        )}
        {'user_phone' in activeChat && (
          <div
            ref={dotsButtonRef}
            className={`${styles.header__controls__control} ${styles.header__controls__options}`}
            title={'Show options menu'}
            onClick={() => setOptionsIsVisible((prevState) => !prevState)}
          >
            <Dots />
          </div>
        )}
        {optionsIsVisible && (
          <OptionsMenu
            id={activeChat.id}
            itemClickHandler={() => setOptionsIsVisible(false)}
            ref={optionsMenuRef}
          />
        )}
      </div>

      <Modal
        className={legacyStyles.groupInfo}
        open={groupInfo}
        footer={null}
        title={<p className={legacyStyles.detailTitle}>Wiser Team</p>}
        closable={true}
        maskClosable={true}
        onCancel={() => setGroupInfo(false)}
        width={500}
      >
        <Input
          className={legacyStyles.searchInput}
          prefix={<SearchOutlined className={legacyStyles.searchIcon} />}
          placeholder="Search"
        />
        <Tabs>
          <TabPane
            key="1"
            tab={<p className={legacyStyles.tabPaneTitle}>About</p>}
          >
            <div className={legacyStyles.about}>
              <h2>Group Name</h2>
              <Input value="Wiser team" />
              <div className={legacyStyles.groupCommands}>
                <img
                  className={legacyStyles.aboutImg}
                  src={profileIcon}
                  alt=""
                />

                <Button
                  className={legacyStyles.deleteBtn}
                  onClick={handleDeleteModal}
                >
                  <p>Delete photo</p>
                  <img src={trashBin} alt="trash-bin" />
                </Button>
                <Button
                  type="default"
                  className={legacyStyles.deleteBtn}
                  onClick={handleDeleteModal}
                >
                  <p>Delete group</p>
                  <img src={trashBin} alt="trash-bin" />
                </Button>
              </div>
            </div>
          </TabPane>
          <TabPane
            key="2"
            tab={<p className={legacyStyles.tabPaneTitle}>Users 6</p>}
          >
            <div className={legacyStyles.addUserDiv} onClick={handleAddUsers}>
              <img src={addUserIcon} alt="add-user-icon" />
              <p>Add User</p>
            </div>

            <div className={legacyStyles.userRow}>
              <img src={profileIcon} alt="user-icon" />
              <p>Cristiano Ronaldo</p>
            </div>
            <div className={legacyStyles.userRow}>
              <img src={profileIcon} alt="user-icon" />
              <p>Cristiano Ronaldo</p>
            </div>
            <div className={legacyStyles.userRow}>
              <img src={profileIcon} alt="user-icon" />
              <p>Cristiano Ronaldo</p>
            </div>
            <div className={legacyStyles.userRow}>
              <img src={profileIcon} alt="user-icon" />
              <p>Cristiano Ronaldo</p>
            </div>
            <div className={legacyStyles.userRow}>
              <img src={profileIcon} alt="user-icon" />
              <p>Cristiano Ronaldo</p>
            </div>
            <div className={legacyStyles.userRow}>
              <img src={profileIcon} alt="user-icon" />
              <p>Cristiano Ronaldo</p>
            </div>
            <div className={legacyStyles.userRow}>
              <img src={profileIcon} alt="user-icon" />
              <p>Cristiano Ronaldo</p>
            </div>
          </TabPane>
        </Tabs>
      </Modal>

      <Modal
        className={legacyStyles.addUsers}
        open={addUsers}
        footer={null}
        title={<p className={legacyStyles.detailTitle}>Add Users</p>}
        closable={true}
        maskClosable={true}
        onCancel={() => setAddUsers(false)}
        width={500}
      >
        <Input
          className={legacyStyles.searchInput}
          prefix={<SearchOutlined className={legacyStyles.searchIcon} />}
          placeholder="Search"
        />

        <div className={legacyStyles.userRow}>
          <input type="checkbox" className={legacyStyles.checkbox} />
          <img src={profileIcon} alt="user-icon" />
          <p>Cristiano Ronaldo</p>
        </div>
        <div className={legacyStyles.userRow}>
          <input type="checkbox" className={legacyStyles.checkbox} />
          <img src={profileIcon} alt="user-icon" />
          <p>Cristiano Ronaldo</p>
        </div>
        <div className={legacyStyles.userRow}>
          <input type="checkbox" className={legacyStyles.checkbox} />
          <img src={profileIcon} alt="user-icon" />
          <p>Cristiano Ronaldo</p>
        </div>
        <div className={legacyStyles.userRow}>
          <input type="checkbox" className={legacyStyles.checkbox} />
          <img src={profileIcon} alt="user-icon" />
          <p>Cristiano Ronaldo</p>
        </div>
        <div className={legacyStyles.userRow}>
          <input type="checkbox" className={legacyStyles.checkbox} />
          <img src={profileIcon} alt="user-icon" />
          <p>Cristiano Ronaldo</p>
        </div>
        <div className={legacyStyles.userRow}>
          <input type="checkbox" className={legacyStyles.checkbox} />
          <img src={profileIcon} alt="user-icon" />
          <p>Cristiano Ronaldo</p>
        </div>
        <div className={legacyStyles.userRow}>
          <input type="checkbox" className={legacyStyles.checkbox} />
          <img src={profileIcon} alt="user-icon" />
          <p>Cristiano Ronaldo</p>
        </div>

        <div>
          <div className={legacyStyles.lastBtns}>
            <Button className={legacyStyles.cancelBtn}>Cancel</Button>
            <Button className={legacyStyles.createGroupBtn}>Add</Button>
          </div>
        </div>
      </Modal>

      <Modal
        className={legacyStyles.deleteModal}
        open={deleteModal}
        footer={null}
        closeIcon={null}
        onCancel={() => setDeleteModal(false)}
        width={376}
      >
        <div className={legacyStyles.bin}>
          <img src={trashBin} alt="trash-bin" />
        </div>
        <p>Are you sure you want to delete?</p>
        <div className={legacyStyles.btns}>
          <Button>Cancel</Button>
          <Button>Delete</Button>
        </div>
      </Modal>
    </div>
  );
};
